import {useContext, createContext} from "react";

export const ShopChatContext = createContext(undefined);

export default function useShop(){
	return useContext(ShopChatContext);
}
